import styled from 'styled-components';
import { IconStyled, TextFieldStyled } from '@bechtel/gds';

export const SearchFieldContainer = styled.div`
  flex-grow: 1;
  position: relative;

  ${TextFieldStyled} {
    padding-right: ${({ theme }) => `calc(${theme.spacings[700]} + ${theme.spacings[400]})`};
  }

  ${IconStyled} {
    position: absolute;
    right: ${({ theme }) => theme.spacings[400]};
    top: 50%;
    transform: translateY(-50%);
  }
`;
